import { LedgerItemDetailDto, LedgerSearchResponseDto, LedgerSummaryDto } from '@inosio/payments-sdk';
import { createSlice } from '@reduxjs/toolkit';
import { ErrorType, RootState } from '../../../app/store';

interface ILedgerDetailItemDataPage {
  Rows: Array<LedgerItemDetailDto>;
}

type OwnerLedgerState = {
  //all ledgers without line items
  isFetchingOwnerLedgers: boolean;
  isFetchingOwnerLedgersFailed: boolean;
  isFetchingOwnerLedgersSuccess: boolean;
  ownerLedgersFetchResponse: LedgerSummaryDto[];
  ownerLedgersFetchError: ErrorType;

  // one ledger with line items
  isFetchingOwnerLedgerDetailItems: boolean;
  isFetchingOwnerLedgerDetailItemsFailed: boolean;
  isFetchingOwnerLedgerDetailItemsSuccess: boolean;
  ownerLedgerDetailItemFetchResponse: LedgerSearchResponseDto;
  ownerLedgerDetailItemFetchError: ErrorType;
  ownerLedgerDetailItemsDataPages: Array<ILedgerDetailItemDataPage>;
};
const getInitialState = () => {
  return {
    //all ledgers without line items
    isFetchingOwnerLedgers: false,
    isFetchingOwnerLedgersFailed: false,
    isFetchingOwnerLedgersSuccess: false,
    ownerLedgersFetchResponse: [] as LedgerSummaryDto[],
    ownerLedgersFetchError: {} as ErrorType,

    // one ledger with line items
    isFetchingOwnerLedgerDetailItems: false,
    isFetchingOwnerLedgerDetailItemsFailed: false,
    isFetchingOwnerLedgerDetailItemsSuccess: false,
    ownerLedgerDetailItemFetchError: {} as ErrorType,
    ownerLedgerDetailItemFetchResponse: {} as LedgerSearchResponseDto,
    ownerLedgerDetailItemsDataPages: [],
  } as OwnerLedgerState;
};

const ownerLedgerSlice = createSlice({
  name: 'ownerLedger',
  initialState: getInitialState(),
  reducers: {
    getAllOwnerLedgers(state, action) {
      state.isFetchingOwnerLedgers = true;
      state.isFetchingOwnerLedgersFailed = false;
      state.isFetchingOwnerLedgersSuccess = false;
    },
    setAllOwnerLedgers(state, action) {
      state.isFetchingOwnerLedgers = false;
      state.isFetchingOwnerLedgersSuccess = true;
      state.ownerLedgersFetchResponse = action.payload;
    },
    setAllOwnerLedgersFetchError(state, action) {
      state.isFetchingOwnerLedgers = false;
      state.isFetchingOwnerLedgersFailed = true;
      state.isFetchingOwnerLedgersSuccess = false;
      state.ownerLedgersFetchError = action.payload;
    },
    getOwnerLedgerDetailItems(state) {
      state.isFetchingOwnerLedgerDetailItems = true;
      state.isFetchingOwnerLedgerDetailItemsFailed = false;
      state.isFetchingOwnerLedgerDetailItemsSuccess = false;
    },
    setOwnerLedgerDetailItems(state, action) {
      state.isFetchingOwnerLedgerDetailItems = false;
      state.isFetchingOwnerLedgerDetailItemsSuccess = true;

      const _payload = action.payload as LedgerSearchResponseDto;

      //get a copy of the current book
      let currentLedgerPages = [...state.ownerLedgerDetailItemsDataPages];

      //if startindex = 0, just reset the book because that means it's loading for the first time or he reset the range size
      if (_payload.StartIndex === 0) currentLedgerPages = [];

      //find out what page we are on
      const whatPageResultsIsThis = Math.ceil(_payload.StartIndex / _payload.RangeSize);

      //now, add this new data page to our book
      currentLedgerPages[whatPageResultsIsThis] = {
        Rows: _payload?.Rows,
      };

      //return the full
      state.ownerLedgerDetailItemFetchResponse = action.payload;
      state.ownerLedgerDetailItemsDataPages = currentLedgerPages;
    },
    setOwnerLedgerDetailItemsFetchError(state, action) {
      state.isFetchingOwnerLedgerDetailItems = false;
      state.isFetchingOwnerLedgerDetailItemsFailed = true;
      state.isFetchingOwnerLedgerDetailItemsSuccess = false;
      state.ownerLedgerDetailItemFetchError = action.payload;
    },
    resetOwnerLedgerState(state) {
      return getInitialState();
    },
  },
});

export const {resetOwnerLedgerState, getOwnerLedgerDetailItems, setOwnerLedgerDetailItems, setOwnerLedgerDetailItemsFetchError, getAllOwnerLedgers, setAllOwnerLedgers, setAllOwnerLedgersFetchError } =
  ownerLedgerSlice.actions;

export default ownerLedgerSlice.reducer;
export const selectOwnerLedgerState = (state: RootState) => state.ownerLedgerState;
export const selectOwnerLedgerDetailItemsCurrentPage = (state: RootState) => state.ownerLedgerState.ownerLedgerDetailItemsDataPages;
